import * as React from 'react';

import './styles.css';

interface CollapsableContainerProps {
    opened: boolean;
    onClick?: () => void;
    title: string | JSX.Element;
    hideToggle?: boolean;
    className?: string; // defaults to ""
}

/**
 * Reusable component that renders a small container that can be toggled. 
 */
export class CollapsibleContainer extends React.PureComponent<CollapsableContainerProps> {
    public render() {
        return (
            <div className={"collapsible-container" + " " + (this.props.className ?? "")}>
                <div className="title-full-content" onClick={e => this.props.onClick && this.props.onClick()}>
                    <div className="expand-icon">
                        {this.props.hideToggle ? <span className="toggle-placeholder"/> : <span className={"glyphicon glyphicon-chevron-" + (this.props.opened ? "up" : "down")} />}
                    </div>
                    <div className="title">{this.props.title}</div>
                </div>
                {this.props.opened && !this.props.hideToggle &&
                    <div className="children">{this.props.children}</div>}
            </div>
        )
    }
}